/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';

import close from 'assets/img/icons/close.svg';
import { Container, Tags } from './styles';
import InputSearch from '../InputSearch';
import WhatsConfimationModal from '../../../TaskList/Row/WhatsConfirmationModal';

function TagInput({
  options, labels, handleAddition, handleDelete,
}) {
  const [optLabels, setOptLabels] = useState(options);
  const [params, setParams] = useState({});
  const [isOpenWhatsConfModal, setIsOpenWhatsConfModal] = useState(false);

  const checkForMatch = (array, propertyToMatch, valueToMatch) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i][propertyToMatch] === valueToMatch) return true;
    }
    return false;
  };

  const checkSendWhats = (option) => {
    if (option.id === 11) { // aguardando inquilino
      setParams(option);
      setIsOpenWhatsConfModal(!isOpenWhatsConfModal);
    } else {
      handleAddition({ ...option, isSendWhats: false });
    }
  };

  useEffect(() => {
    let filterOptions = options;
    if (labels && options) {
      options.forEach((option) => {
        if (checkForMatch(labels, 'id', option.id)) {
          filterOptions = filterOptions.filter(opt => opt.id !== option.id);
        }
      });
    }
    setOptLabels(filterOptions);
  }, [options, labels]);

  return (
    <>
      <Container>
        {labels && labels.map(label => (
          <Tags>
            {label.name}
            <img
              onClick={() => handleDelete(label)}
              style={{ marginLeft: '3px', marginRight: '3px', width: '8px' }}
              src={close}
              alt="Fechar"
            />
          </Tags>
        ))}
        <InputSearch onSelected={checkSendWhats} options={optLabels} placeholder="Adicionar" />
      </Container>
      <WhatsConfimationModal
        isOpen={isOpenWhatsConfModal}
        params={params}
        _setAction={handleAddition}
        _setIsOpenWhatsConfModal={setIsOpenWhatsConfModal}
        text="Deseja enviar uma mensagem para o Whatsapp do cliente solicitando mais detalhes para avançar no envio dos orçamentos?"
      />
    </>
  );
}

export default TagInput;
